import * as React from "react";

/**
 * Текст сообщения чата → куски с кликабельными ссылками.
 *
 * Контракт: на вход сырой текст, на выход массив строк и <a target="_blank">.
 * Ссылкой считается то, что начинается с http(s):// или www., а также «голый»
 * домен с путём (meet.google.com/abc-defg-hij, zoom.us/j/123) — так ссылку
 * копирует сам Google Meet. Без пути домен не трогаем, чтобы не ловить «т.е.».
 * Знаки препинания в хвосте (точка, запятая, скобка) в ссылку не входят.
 * Время линейное от длины текста: сообщения пишут студенты, а рендерятся они
 * у менеджера на каждой перерисовке чата.
 */

/* Ссылка начинается только с начала строки или после символа вне домена (группа
   префикса): иначе поиск стартует с каждой границы внутри «a-a-a-…» и на длинном
   сообщении становится квадратичным. Пределы {1,63} и {2,24} — длина метки домена
   (RFC 1035) и самой длинной зоны. Без флага g: split и так режет по всем
   совпадениям, а test с g помнит lastIndex. */
const URL_RE = /(^|[^a-z0-9-])((?:https?:\/\/|www\.)[^\s<]+|(?:[a-z0-9-]{1,63}\.){1,10}[a-z]{2,24}\/[^\s<]*)/i;
const TRAILING_PUNCT = ".,;:!?)]}\"'»";

export function hasLink(text: string) {
  return URL_RE.test(text);
}

export function linkifyText(text: string, linkClassName: string): React.ReactNode[] {
  return text.split(URL_RE).map((part, index) => {
    /* split с двумя группами раскладывает так: [текст, префикс, ссылка, текст, …] */
    if (index % 3 !== 2) return part;

    /* хвост срезаем циклом: регулярка с $ на длинной серии знаков квадратична */
    let end = part.length;
    while (end > 0 && TRAILING_PUNCT.includes(part[end - 1])) end--;
    const url = part.slice(0, end);
    const href = /^https?:\/\//i.test(url) ? url : `https://${url}`;

    return (
      <React.Fragment key={index}>
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className={linkClassName}
          /* клик по ссылке во всплывашке не должен ещё и открывать чат */
          onClick={(e) => e.stopPropagation()}
        >
          {url}
        </a>
        {part.slice(end)}
      </React.Fragment>
    );
  });
}
